export default __webpack_public_path__ + "static/media/unarchive.509c22f1.svg";